const vertexShader = `
  varying vec3 vPosition;
  varying vec2 vUv;
  void main(){
    vUv = uv;
    vPosition = position;
    gl_Position = projectionMatrix*viewMatrix*modelMatrix*vec4( position, 1.0 );
  }
`;

// fragmentShdaer字符串
const fragmentShader = `
  uniform sampler2D baseTexture;
  uniform float maxZ;
  uniform float minZ;
  uniform float threshold;
  uniform float rate;
	uniform vec3 color;
  varying vec3 vPosition;
  varying vec2 vUv;

  void main() {
    float zFactor = mod(rate, 1.0) * (maxZ - minZ) + minZ;
    float distanceToGlowLine = abs(vPosition.z - zFactor);
    vec4 baseColor = texture2D(baseTexture, vUv);
    if (threshold * (maxZ - minZ) > distanceToGlowLine) {
      float colorOpacity = distanceToGlowLine / (threshold * (maxZ - minZ));
      gl_FragColor = vec4(color, 1.0) * (1.0 - colorOpacity) + baseColor * colorOpacity;
    } else {
      gl_FragColor = baseColor;
    }
  }
`;

export { vertexShader, fragmentShader };
